import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Section from '../common/Section';
import { getAllBlogPosts } from '../../lib/markdown';
import type { BlogPost } from '../../types/blog';
import { format } from 'date-fns';
import { zhCN } from 'date-fns/locale';

export default function LatestBlog() {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllBlogPosts().then(data => {
      setPosts(data.slice(0, 3));
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <Section>
        <div className="container-custom">
          <h2 className="text-5xl md:text-6xl font-heading font-bold mb-12 text-center">
            最新博客
          </h2>
          <div className="text-center text-xl">加载中...</div>
        </div>
      </Section>
    );
  }

  if (posts.length === 0) {
    return (
      <Section>
        <div className="container-custom">
          <h2 className="text-5xl md:text-6xl font-heading font-bold mb-12 text-center">
            最新博客
          </h2>
          <div className="text-center text-xl text-gray-600">
            暂无博客文章
          </div>
        </div>
      </Section>
    );
  }

  return (
    <Section className="bg-white">
      <div className="container-custom">
        <h2 className="text-5xl md:text-6xl font-heading font-bold mb-12 text-center">
          最新博客
        </h2>
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {posts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="card-neubrutal bg-white p-6 rounded-lg"
            >
              <div className="aspect-video mb-4 bg-gradient-to-br from-secondary/20 to-primary/20 border-2 border-black rounded-lg flex items-center justify-center">
                <span className="text-6xl">📝</span>
              </div>
              <h3 className="text-2xl font-heading font-bold mb-2">
                {post.title}
              </h3>
              <p className="text-sm text-gray-500 mb-3">
                {format(new Date(post.date), 'yyyy年MM月dd日', { locale: zhCN })}
              </p>
              <p className="text-gray-600 mb-4 line-clamp-2">
                {post.excerpt}
              </p>
              <div className="flex flex-wrap gap-2">
                {post.tags.slice(0, 2).map((tag) => (
                  <span
                    key={tag}
                    className="text-xs px-2 py-1 border-2 border-black bg-primary text-white rounded-full"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center">
          <Link to="/blog" className="btn-neubrutal bg-secondary text-black px-8 py-3">
            查看所有博客
          </Link>
        </div>
      </div>
    </Section>
  );
}
